/* ELLESANTI V3 · homepage: movimenti legati allo scroll (19/10/2026).
   0 La foto grande in apertura (hero) resta ferma come un livello di sotto: la fascia dei loghi, le tipologie e
     «Lo stile Ellesanti» le scorrono sopra (con la linea sottile sul bordo del primo livello).
   1 «Lo stile Ellesanti»: il blocco entra un po' più in basso e risale; dentro le card la foto scorre più lenta
     del riquadro (parallasse leggera: zoom 1,1 e spostamento massimo 4,5%, così il gioiello non viene tagliato).
   2 Il video «Una direzione di lettura» resta fermo come un livello di sotto e la gift card gli scorre sopra.
   3 Ogni sezione dopo il video entra un po' più in basso e risale; gift card: testo e carta a velocità diverse.
   4 Fondo pagina: il contenuto scorre normale finché il suo fondo arriva a MAIN_STOP dello schermo, poi si ferma;
     garanzie e footer salgono sopra di lui. Nessuna linea sui bordi.
     Desktop: garanzie e footer restano attaccati fino alla fine della pagina (le garanzie non vengono coperte).
     Mobile: quando il fondo delle garanzie arriva a TRUST_STOP si fermano e il footer passa sopra di loro.
   Con «riduci movimento» non fa nulla. */
(function () {
  if (!window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var D_DESK = 140, D_MOB = 70, FOLLOW = 0.16, IMG = 3.6, ZOOM = 1.1, LINEA = '1px solid #DDD7CD';
  var MAIN_STOP = 0.8, TRUST_STOP = 0.45, DESK = matchMedia('(min-width: 1024px)');
  var items = [], imgs = [], raf = 0, pins = [], sotto = [], over = [], main = null, sale = false;

  function add(sec, el, f) { if (el) items.push({ sec: sec, el: el, f: f, cur: null }); }
  function opaque(s) {
    var bg = getComputedStyle(s).backgroundColor;
    if (!bg || bg === 'transparent' || bg === 'rgba(0, 0, 0, 0)') s.style.backgroundColor = '#fff';
  }
  function layer(s, line) {
    s.style.position = 'relative';
    s.style.zIndex = '1';
    opaque(s);
    if (line) s.style.borderTop = LINEA;
  }
  function setup() {
    items = []; imgs = []; pins = []; sotto = []; over = []; sale = false;
    main = document.querySelector('main');
    var met = document.querySelector('[data-e-metodo]');
    var wrap = met && met.closest('.shopify-section');

    // 0 hero sotto, le sezioni dopo (fino al video) sopra
    var hero = document.querySelector('.e-hero');
    var hw = hero && hero.closest('.shopify-section');
    if (hw) {
      pins.push(hw);
      var firstH = true;
      for (var a = hw.nextElementSibling; a && a !== wrap; a = a.nextElementSibling) {
        if (!a.classList.contains('shopify-section') || !a.offsetHeight) continue;
        layer(a, firstH); firstH = false;
      }
    }

    // 1 «Lo stile Ellesanti»
    var ps = document.querySelector('.e-ps');
    if (ps) {
      add(ps, ps.querySelector('.e-wrap'), 0.8);
      Array.prototype.forEach.call(ps.querySelectorAll('.e-card__img'), function (box, i) {
        Array.prototype.forEach.call(box.querySelectorAll('img'), function (im) {
          im.style.willChange = 'transform';
          imgs.push({ box: box, im: im, k: i % 2 ? 1.25 : 1 });
        });
      });
    }

    // 2-3 video sotto, sezioni dopo sopra
    if (wrap) {
      opaque(wrap);   // copre la hero ferma dietro
      pins.push(wrap);
      var first = true;
      for (var s = wrap.nextElementSibling; s; s = s.nextElementSibling) {
        if (!s.classList.contains('shopify-section')) continue;
        layer(s, first); first = false;
        var reg = s.querySelector('#regali');
        if (reg) {
          add(s, reg.querySelector('.e-reg__l'), 1);
          add(s, reg.querySelector('.e-reg__r'), 1.7);
        } else if (s.firstElementChild) {
          add(s, s.firstElementChild, 1);
        }
      }
    }

    // 4 contenuto fermo, garanzie + footer sopra
    var foots = Array.prototype.filter.call(document.querySelectorAll('.shopify-section-group-footer-group'), function (f) {
      return f.querySelector('.e-trust, .e-ft') && f.offsetHeight > 0;
    });
    foots.forEach(function (f) { (f.querySelector('.e-trust') && !over.length ? sotto : over).push(f); });
    if (main && foots.length) {
      sale = true;
      foots.forEach(function (f) { layer(f, false); });
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(stick);
        ro.observe(main);
        sotto.forEach(function (u) { ro.observe(u); });
      }
    }
    stick();
  }
  // un blocco si ferma quando il suo fondo arriva in fondo allo schermo
  function pinBottom(el) {
    el.style.position = '';
    el.style.top = '';
    var h = el.offsetHeight;
    el.style.position = 'sticky';
    el.style.top = Math.min(0, innerHeight - h) + 'px';
    el.style.zIndex = '0';
  }
  // un blocco si ferma quando il suo fondo arriva alla quota y dello schermo
  function pinAt(el, y) {
    el.style.position = ''; el.style.top = '';
    var h = el.offsetHeight;
    el.style.position = 'sticky';
    el.style.top = (Math.round(y) - h) + 'px';
  }
  function stick() {
    pins.forEach(pinBottom);
    if (!sale) return;
    pinAt(main, innerHeight * MAIN_STOP);
    var mob = !DESK.matches && over.length;
    over.forEach(function (f) { f.style.zIndex = mob ? '2' : '1'; });
    var y = innerHeight * TRUST_STOP;
    for (var i = sotto.length - 1; i >= 0; i--) {
      var t = sotto[i];
      if (mob) { pinAt(t, y); y -= t.offsetHeight; }
      else { t.style.position = 'relative'; t.style.top = ''; }
    }
  }
  function frame() {
    raf = 0;
    var vh = innerHeight, D = innerWidth >= 1024 ? D_DESK : D_MOB, again = false, i;
    for (i = 0; i < items.length; i++) {
      var it = items[i], r = it.sec.getBoundingClientRect();
      var t = Math.max(0, Math.min(1, (vh - r.top) / (vh * 0.85)));
      var target = Math.pow(1 - t, 3) * D * it.f;
      var c = it.cur === null ? target : it.cur + (target - it.cur) * FOLLOW;
      if (Math.abs(target - c) < 0.3) c = target; else again = true;
      it.cur = c;
      it.el.style.transform = c < 0.5 ? '' : 'translate3d(0,' + c.toFixed(1) + 'px,0)';
    }
    for (i = 0; i < imgs.length; i++) {
      var o = imgs[i], b = o.box.getBoundingClientRect();
      if (b.bottom < -100 || b.top > vh + 100) continue;
      var q = Math.max(-1, Math.min(1, (b.top + b.height / 2 - vh / 2) / (vh / 2 + b.height / 2)));
      o.im.style.transform = 'translate3d(0,' + (q * IMG * o.k).toFixed(2) + '%,0) scale(' + ZOOM + ')';
    }
    if (again) raf = requestAnimationFrame(frame);
  }
  function kick() { if (!raf) raf = requestAnimationFrame(frame); }
  function start() {
    setup();
    kick();
    addEventListener('scroll', kick, { passive: true });
    var lw = innerWidth;
    addEventListener('resize', function () { if (innerWidth !== lw) { lw = innerWidth; stick(); } kick(); });
    addEventListener('load', function () { stick(); kick(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();